import React from 'react';
import { Form, Button, Card, InputGroup, Spinner } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import { Formik, Form as FForm } from 'formik';
import { string, object, InferType } from 'yup'; // for only what you need
import { useWhyDidYouUpdate } from '../../hooks';
// import withSizes from 'react-sizes';
/**
 * Setup Yup Validation
 */
const validationSchema = object().shape({
  postalcode: string().required(),
});

export type FormDataType = InferType<typeof validationSchema>;

type Props = {
  message?: string | null;
  loading?: boolean;
  onSubmit: (values, action) => void;
  isMobile?: boolean;
};

const LoginFormPostal = ({ message = ' ', loading = false, onSubmit, isMobile }: Props) => {
  /*-------------------- Body -----------------------------------------------*/

  useWhyDidYouUpdate('[LoginForm]', { message, onSubmit });
  /*-------------------- Render ---------------------------------------------*/
  return (
    <Formik
      initialValues={{ postalcode: '' }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formikBag) => (
        <Card className="bg-light shadow-sm p-3 mb-5 login-size">
          <Card.Body>
            <Card.Title className="text-center mb-4 mt-1" as="h4">
              <img alt="" src={process.env.PUBLIC_URL + '/logo.png'} className="mx-auto d-block" />
            </Card.Title>
            <p className="text-danger text-center">{message && ''}</p>
            <div className="text-hdr-normal font-weight-bold mb-4 ml-3 text-center">
              Για το συγκεκριμένο ΑΦΜ/Τηλέφωνο υπάρχουν πάνω από 1 σημεία συλλογής. <br /> Παρακαλώ
              εισάγετε και τον Ταχυδρομικό Κώδικα.
            </div>

            <Form as={FForm}>
              <Form.Group>
                <InputGroup>
                  <InputGroup.Text>
                    <FaUser />
                  </InputGroup.Text>
                  {isMobile ? (
                    <Form.Control
                      size="lg"
                      className="rounded-right"
                      id="postalcode"
                      type="text"
                      placeholder="ΤΚ"
                      {...formikBag.getFieldProps('postalcode')}
                      isInvalid={!!formikBag.touched.postalcode && !!formikBag.errors.postalcode}
                    />
                  ) : (
                    <Form.Control
                      className="rounded-right"
                      id="postalcode"
                      type="text"
                      placeholder="ΤΚ"
                      {...formikBag.getFieldProps('postalcode')}
                      isInvalid={!!formikBag.touched.postalcode && !!formikBag.errors.postalcode}
                    />
                  )}

                  <Form.Control.Feedback type="invalid">
                    Ο ταχυδρομικός κώδικας απαιτείται. Δεν μπορεί να είναι κενός
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              {isMobile ? (
                <Button
                  block
                  variant="primary"
                  size="lg"
                  style={{ fontSize: '0.8rem' }}
                  type="submit"
                  disabled={!(formikBag.isValid && formikBag.dirty)}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" className="mx-2" />
                  ) : (
                    <span></span>
                  )}
                  <span>{'Είσοδος'}</span>
                </Button>
              ) : (
                <Button
                  block
                  variant="primary"
                  size="sm"
                  style={{ fontSize: '0.8rem' }}
                  type="submit"
                  disabled={!(formikBag.isValid && formikBag.dirty)}
                >
                  {loading ? (
                    <Spinner animation="border" size="sm" className="mx-2" />
                  ) : (
                    <span></span>
                  )}
                  <span>{'Είσοδος'}</span>
                </Button>
              )}
            </Form>
          </Card.Body>
          {/* <a onClick={() => history.push(generatePath(getRouteByName('ForgotPw')))} className="forgot-pw" href="#">
            <p> Ξέχασα τον κωδικό μου </p>{' '}
          </a> */}
        </Card>
      )}
    </Formik>
  );
};

// const mapSizesToProps = ({ width }) => ({
//   isMobile: width < 768,
// });

export default LoginFormPostal;
